module.exports = __webpack_public_path__ + "img/icon_exhibition_2023@2x.0d571fee.png";